import React, { useState } from "react"

import { Stack, Avatar, TextField, IconButton } from "@mui/material"

import useAuth from "../../hooks/useAuth"
import { useDispatch } from "react-redux"
import { createComment } from "./commentSlice"
import { Send } from "@mui/icons-material"

function CommentForm({ postId }) {
	const { user } = useAuth()
	const [content, setContent] = useState("")
	const dispatch = useDispatch()

	const handleSubmit = (e) => {
		e.preventDefault()
		dispatch(createComment({ postId, content }))
		setContent("")
	}

	return (
		<form onSubmit={handleSubmit}>
			<Stack direction="row" alignItems="center">
				<Avatar src={user.avatarUrl} alt={user.name} />
				<TextField
					fullWidth
					size="small"
					value={content}
					autoComplete={"false"}
					placeholder="Write a comment…"
					onChange={(event) => setContent(event.target.value)}
					sx={{
						ml: 2,
						mr: 1,
						"& fieldset": {
							borderWidth: `1px !important`,
							borderColor: (theme) =>
								`${theme.palette.grey[500_32]} !important`,
						},
					}}
				/>
				<IconButton type="submit">
					<Send sx={{ fontSize: 30 }} />
				</IconButton>
			</Stack>
		</form>
	)
}

export default CommentForm
